import { NoMatch } from "./page/error/404";
import Unauthorised from "./page/error/unauthorised";
import Modal from "react-modal";
import { Checkout } from "./page/checkout";
import { Navigate, Route, Routes } from "react-router";

import "react-toastify/dist/ReactToastify.min.css";
import { Logger } from "aws-amplify";
import { ToastContainer } from "../tabin/components/toast";
import { RestaurantList } from "./page/restaurantList";
import { Logout } from "./page/auth/logout";
import { BrowserRouter } from "react-router-dom";
import { OrderPlaced } from "./page/orderPlaced";
import { Restaurant } from "./page/restaurant";
import { AuthenticationStatus, useAuth } from "../context/auth-context";
import { useUser } from "../context/user-context";
import { FullScreenSpinner } from "../tabin/components/fullScreenSpinner";
import Login from "./page/auth/login";
import Signup from "./page/auth/signup";
import SignupConfirm from "./page/auth/signupConfirm";
import ForgotPassword from "./page/auth/forgotPassword";
import ForgotPasswordReset from "./page/auth/forgotPasswordReset";
import NewInformationRequired from "./page/auth/newInformationRequired";
import AuthRedirect from "./page/auth/authRedirect";
import { AppWrapper } from "./common/appWrapper";
import { Rewards } from "./page/rewards";
import { Account } from "./page/account";
import { Promotions } from "./page/promotions";

let electron: any;
let ipcRenderer: any;
try {
    electron = window.require("electron");
    ipcRenderer = electron.ipcRenderer;
} catch (e) {}

const logger = new Logger("Main");

Modal.setAppElement("#root");

// Auth routes
export const authRedirectPath = "/auth_redirect";
export const loginPath = "/login";
export const signUpPath = "/signup";
export const signUpConfirmPath = "/signup_confirm";
export const forgotPasswordPath = "/forgot_password";
export const forgotPasswordResetPath = "/forgot_password_reset";
export const newInformationRequiredPath = "/new_information_required";
export const landingPath = "/landing";
export const restaurantsListPath = "/";

export const restaurantListPath = "/";
export const restaurantPath = "/restaurant";
export const checkoutPath = "/checkout";
export const orderPlacedPath = "/order_placed";
export const logoutPath = "/log_out";
export const unauthorizedPath = "/unauthorized";

export const accountPath = "/account";
export const rewardsPath = "/rewards";
export const promotionsPath = "/promotions";

export default () => {
    return (
        <>
            <BrowserRouter>
                <AppRoutes />
            </BrowserRouter>
            <ToastContainer />
        </>
    );
};

const AppRoutes = () => {
    return (
        <Routes>
            <Route path={authRedirectPath} element={<AuthRedirect />} />
            <Route path={loginPath} element={<Login />} />
            <Route path={signUpPath} element={<Signup />} />
            <Route path={signUpConfirmPath} element={<SignupConfirm />} />
            <Route path={forgotPasswordPath} element={<ForgotPassword />} />
            <Route path={forgotPasswordResetPath} element={<ForgotPasswordReset />} />
            <Route path={newInformationRequiredPath} element={<NewInformationRequired />} />
            <Route path={logoutPath} element={<Logout />} />
            <Route path={restaurantListPath} element={<RestaurantPrivateRoute element={<RestaurantList />} />} />
            <Route path={checkoutPath} element={<RestaurantPrivateRoute element={<Checkout />} />} />
            <Route path={`${orderPlacedPath}`} element={<RestaurantPrivateRoute element={<OrderPlaced />} />} />
            <Route path={rewardsPath} element={<RestaurantPrivateRoute element={<Rewards />} />} /> {/* Old method */}
            <Route path={promotionsPath} element={<RestaurantPrivateRoute element={<Promotions />} />} /> {/* Old method */}
            <Route path={accountPath} element={<RestaurantPrivateRoute element={<Account />} />} /> {/* Old method */}
            <Route path={`${restaurantPath}/:restaurantId`} element={<RestaurantPrivateRoute element={<Restaurant />} />} /> {/* Old method */}
            <Route path={`:restaurantId`} element={<RestaurantPrivateRoute element={<Restaurant />} />} />
            <Route path={unauthorizedPath} element={<Unauthorised />} />
            <Route path="*" element={<NoMatch />} />
        </Routes>
    );
};

const PrivateRoute = ({ element }) => {
    const { status } = useAuth();
    const { user, isLoading } = useUser();

    if (status !== AuthenticationStatus.SignedIn) return <Navigate to={loginPath} />; // Handle other authentication statuses
    if (isLoading) return <FullScreenSpinner show={true} text="Loading user..." />; // Assumed signed in from this point onwards
    if (!user) throw "Signed in but no user found in database";

    return element; // Route to original path
};

const RestaurantPrivateRoute = ({ element }) => {
    return <PrivateRoute element={<AppWrapper>{element}</AppWrapper>} />;
};
